"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var querystring_1 = __importDefault(require("querystring"));
var lodash_1 = require("lodash");
var splitUrl_1 = __importDefault(require("./splitUrl"));
var filterEmptyKeys = function (obj) { return lodash_1.pickBy(obj, function (_, key) { return !!key; }); };
/**
 * Extracts query params from a URL and returns them as an object.
 *
 * Filters out empty params so the returned object has defined values.
 */
var extractParams = function (url) {
    if (url === void 0) { url = ''; }
    var params = querystring_1.default.parse(splitUrl_1.default(url).queryString);
    // Handles a params object that was extracted from an URL with a trailing `&`,
    // which would result in an empty key/value pair.
    return filterEmptyKeys(params);
};
exports.default = extractParams;
